import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import '@fortawesome/fontawesome-free/js/all.js';
import { FieldType } from '@ngx-formly/core';
import { Storage } from 'aws-amplify';
import { ModalComponent } from './../modal/modal.component';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'image-link-type',
  template: `
    <button 
      mat-icon-button 
      class="image-link-button" 
      (click)="getImagePath()"
      matTooltip="Open image"
    >
      <mat-icon>open_in_new</mat-icon>
    </button>
  `,
  styles: [`
    .image-link-button {
      color: #0097ac;
      margin-left: 12px;
      transition: all 0.2s ease-in-out;
    }

    .image-link-button:hover {
      color: #007a8a;
      transform: scale(1.1);
      background-color: rgba(0, 151, 172, 0.1);
    }

    .image-link-button mat-icon {
      font-size: 24px;
      width: 24px;
      height: 24px;
    }
  `]
})
export class ImageLinkTypeComponent extends FieldType {
  constructor(public dialog: MatDialog) {
    super();
  }
  onClick() {
    this.getImagePath();
  }
  getImagePath() {
    console.log('this.to',this.to)
    const imagePath = this.to['url'];
    let bucketName = imagePath.replace('s3://', '');
    const array = bucketName.split('/');
    bucketName = array[0];
    Storage.get(imagePath.replace('s3://' + bucketName + '/', ''), {
      bucket: bucketName,
    })
      .then((data) => {
        const dialogRef = this.dialog.open(ModalComponent, {
          width: '99vw',
          maxWidth: '99vw',
          height: '99vh',
          panelClass: 'stretch-dialog',
          data: {
            url: data,
            imagePath:imagePath,
            structure: this.to,
            labeling_information: this.to['labeling_information'],
            id: this.to['id'],
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log('closed');
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
